// oxlint-disable
import { isEmptyHTML } from '@/app/util/editor/editor';

const MIGRATION_KEY = 'ziggu_migration_ticket_draft_signatures_v2';
const DRAFT_KEY_PATTERNS = ['employee_tickets_drafts_', 'customer_tickets_drafts_', 'partner_tickets_drafts_'];

function removeDuplicateSignatures(content, signature) {
  if (!content || !signature || isEmptyHTML(signature)) return content;

  const signature_trimmed = signature.trim();
  if (!signature_trimmed) return content;

  const escapeForRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s*');
  const signature_pattern = escapeForRegex(signature_trimmed);

  // Match signature with optional surrounding empty paragraphs, globally
  const regex = new RegExp(`(<p>\\s*</p>\\s*)*${signature_pattern}(\\s*<p>\\s*</p>)*`, 'gi');
  const matches = content.match(regex);

  if (!matches || matches.length <= 1) return content;

  // Remove all occurrences except potentially the last one
  let result = content;
  for (let i = 0; i < matches.length - 1; i += 1) {
    result = result.replace(matches[i], '');
  }

  // Clean up any resulting multiple empty paragraphs
  result = result.replace(/(<p>\s*<\/p>\s*){2,}/g, '<p></p>');

  return result.trim();
}

function cleanDraftPayload(payload, signature) {
  if (!payload || typeof payload !== 'object') return payload;

  const cleaned = { ...payload };
  let changed = false;

  if (cleaned.reply && !isEmptyHTML(cleaned.reply)) {
    const clean_reply = removeDuplicateSignatures(cleaned.reply, signature);
    if (clean_reply !== cleaned.reply) {
      cleaned.reply = clean_reply;
      changed = true;
    }
  }

  if (cleaned.note && !isEmptyHTML(cleaned.note)) {
    const clean_note = removeDuplicateSignatures(cleaned.note, signature);
    if (clean_note !== cleaned.note) {
      cleaned.note = clean_note;
      changed = true;
    }
  }

  if (cleaned.content && !isEmptyHTML(cleaned.content)) {
    const clean_content = removeDuplicateSignatures(cleaned.content, signature);
    if (clean_content !== cleaned.content) {
      cleaned.content = clean_content;
      changed = true;
    }
  }

  return { cleaned, changed };
}

function isTicketDraftKey(key) {
  return DRAFT_KEY_PATTERNS.some((pattern) => key.includes(pattern));
}

export function runTicketDraftSignatureMigration(signature) {
  const migration_timestamp = localStorage.getItem(MIGRATION_KEY);
  if (migration_timestamp) {
    return { skipped: true, reason: 'already_migrated', timestamp: migration_timestamp };
  }

  if (!signature || isEmptyHTML(signature)) {
    localStorage.setItem(MIGRATION_KEY, new Date().toISOString());
    return { skipped: true, reason: 'no_signature' };
  }

  let drafts_cleaned = 0;
  let drafts_checked = 0;
  const errors = [];

  // Iterate through all localStorage keys
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (!key || !isTicketDraftKey(key)) continue;

    drafts_checked += 1;

    try {
      const raw_value = localStorage.getItem(key);
      if (!raw_value) continue;

      const payload = JSON.parse(raw_value);
      const { cleaned, changed } = cleanDraftPayload(payload, signature);

      if (changed) {
        localStorage.setItem(key, JSON.stringify(cleaned));
        drafts_cleaned += 1;
      }
    } catch (e) {
      errors.push({ key, error: e.message });
    }
  }

  // Mark migration as complete
  localStorage.setItem(MIGRATION_KEY, new Date().toISOString());

  return {
    skipped: false,
    drafts_checked,
    drafts_cleaned,
    errors: errors.length > 0 ? errors : undefined,
  };
}
